import type { TrainingSearchQuery } from '@rover/rsdk/src/apiClient/latest/model/trainingSearchQuery';

import TrainingUrls from '../../training/constants/urls';
import { appendSearchQueryParams } from '../../training/utils/appendSearchQueryParams';

export const getTrainingSearchUrl = (filters: Partial<TrainingSearchQuery>): string => {
  return appendSearchQueryParams(TrainingUrls.SEARCH, {
    ...filters,
    centerlat: filters.centerlat?.toString(),
    centerlng: filters.centerlng?.toString(),
  });
};
